// custom-date.js
function displayDates(displayNum, fromDate, toDate) {
    var options = { locale: 'fr-FR' };
    document.getElementById('fromDate' + displayNum).innerHTML = fromDate.toString('dddd d MMMM', options);
    document.getElementById('toDate' + displayNum).innerHTML = toDate.toString('dddd d MMMM', options);
  }
  
  // Set 1
  var fromDate1 = Date.today().addDays(2);
  if ( fromDate1.is().saturday() ||  fromDate1.is().sunday()) {
    fromDate1 = fromDate1.next().monday();
  }
  var toDate1 = Date.today().addDays(3);
  if (toDate1.is().saturday() || toDate1.is().sunday()) {
    toDate1 = toDate1.next().monday();
  }

  // Check if today is Friday
  if (Date.today().is().friday()) {
  toDate1 = toDate1.next().tuesday(); // Move to next Tuesday
  }
  displayDates(1, fromDate1, toDate1);
  
  
  // Set 2
  var fromDate2 = Date.today().addDays(2);
  if ( fromDate2.is().saturday() ||  fromDate2.is().sunday()) {
    fromDate2 = fromDate2.next().monday();
  }
  var toDate2 = Date.today().addDays(3);
  if (toDate2.is().saturday() || toDate2.is().sunday()) {
    toDate2 = toDate2.next().monday();
  }
  
  // Check if today is Friday
  if (Date.today().is().friday()) {
    toDate2 = toDate2.next().tuesday(); // Move to next Tuesday
    }
  displayDates(2, fromDate2, toDate2);
  
  // Set 3
  var fromDate3 = Date.today().addDays(2);
  if ( fromDate3.is().saturday() ||  fromDate3.is().sunday()) {
    fromDate3 = fromDate3.next().monday();
  }
  var toDate3 = Date.today().addDays(3);
  if (toDate3.is().saturday() || toDate3.is().sunday()) {
    toDate3 = toDate3.next().monday();
  }
  
  // Check if today is Friday
  if (Date.today().is().friday()) {
    toDate3 = toDate3.next().tuesday(); // Move to next Tuesday
    }
  displayDates(3, fromDate3, toDate3);

/*     // Set 4
    var fromDate4 = Date.today().addDays(2);
    if (fromDate4.is().saturday() || fromDate4.is().sunday()) {
      fromDate4 = fromDate4.next().monday();
    }
    var toDate4 = Date.today().addDays(1);
    if (toDate4.is().saturday() || toDate4.is().sunday()) {
      toDate4 = toDate4.next().monday();
    }
    displayDates(4, fromDate4, toDate4); */
  